<div class="user-details">
  <h2 *ngIf="!UserEmpty()">
    <span id="icon" class="material-icons-outlined">person</span>
    <span class="title-details">{{ userTitle | translate }}</span>
  </h2>
  <div *ngIf="UserEmpty()" class="empty-details">
    <span class="material-icons-outlined empty-icon">person</span>
  </div>

  <div *ngIf="!UserEmpty()" class="user-info-container">
    <div *ngIf="user.value.id !== 0 && !editMode" class="user-info">
      <table>
        <tr>
          <td>
            <strong>{{ "userDetails.name" | translate }}:</strong>
          </td>
          <td>{{ user.value.name }}</td>
        </tr>
        <tr>
          <td>
            <strong>{{ "userDetails.displayname" | translate }}:</strong>
          </td>
          <td>{{ user.value.displayname }}</td>
        </tr>
        <tr>
          <td>
            <strong>{{ "userDetails.email" | translate }}:</strong>
          </td>
          <td>{{ user.value.email }}</td>
        </tr>
        <tr>
          <td>
            <strong>{{ "userDetails.supervisor" | translate }}:</strong>
          </td>
          <td>{{ user.value.supervisor ? "yes" : "No " }}</td>
        </tr>
        <tr>
          <td>
            <strong>{{ "userDetails.active" | translate }}:</strong>
          </td>
          <td>{{ user.value.active ? "yes" : "No" }}</td>
        </tr>
        <user-pass
          *ngIf="supervisor && userPassFormVisible"
          (cancel)="cancelPasswordChange()"
          [selectedUsername]="selectedUser"
        ></user-pass>

        <div *ngIf="supervisor">
          <button
            *ngIf="!userPassFormVisible"
            class="btn-password"
            (click)="userPassFormVisible = true"
          >
            <span class="material-icons">lock_reset</span>
          </button>
        </div>
      </table>

      <div>
        <button *ngIf="supervisor" class="btn-edit" (click)="toggleEditMode()">
          <span class="material-icons-outlined">edit</span>
          {{ "userDetails.editButton" | translate }}
        </button>
        <button *ngIf="supervisor" class="btn-delete" (click)="deleteUser()">
          <span class="material-icons-outlined">delete</span>
          {{ "userDetails.deleteButton" | translate }}
        </button>
      </div>
      <messages
        class="msg"
        [form]="userForm"
        [messagesObserver]="messages"
        [showNonFieldKeys]="TRUE"
        [showFieldName]="TRUE"
        [showFieldKeys]="FALSE"
      ></messages>
    </div>

    <form [formGroup]="userForm" *ngIf="editMode" class="user-form">
      <div class="form-group-flex">
        <div class="form-group">
          <label for="name">{{ "userDetails.name" | translate }}:</label>
          <input type="text" id="name" formControlName="name" />
          <messages
            class="msg"
            [form]="userForm"
            [messagesObserver]="messages"
            fieldname="name"
          ></messages>
        </div>
      </div>
      <div class="form-group">
        <label for="displayname"
          >{{ "userDetails.displayname" | translate }}:</label
        >
        <input type="text" id="displayname" formControlName="displayname" />
        <messages
          class="msg"
          [form]="userForm"
          [messagesObserver]="messages"
          fieldname="displayname"
        ></messages>
      </div>
      <div class="form-group">
        <label for="email">{{ "userDetails.email" | translate }}:</label>
        <input type="email" id="email" formControlName="email" />
        <messages
          class="msg"
          [form]="userForm"
          [messagesObserver]="messages"
          fieldname="email"
        ></messages>
      </div>
      <div class="check">
        <div class="form-group">
          <label for="supervisor"
            >{{ "userDetails.supervisor" | translate }}:</label
          >
          <input type="checkbox" id="supervisor" formControlName="supervisor" />
        </div>
        <div class="form-group">
          <label for="active">{{ "userDetails.active" | translate }}:</label>
          <input type="checkbox" id="active" formControlName="active" />
        </div>
      </div>
      <div class="action-buttons">
        <action-button
          class="btn-save"
          (actionEvent)="saveUser($event)"
          label="{{ 'userDetails.saveButton' | translate }}"
        >
          <span class="material-icons-outlined">save</span>
          {{ "userDetails.saveButton" | translate }}
        </action-button>
        <button type="button" class="btn-cancel" (click)="toggleEditMode()">
          <span class="material-icons-outlined">cancel</span>
          {{ "userDetails.cancelButton" | translate }}
        </button>
      </div>
      <messages
        class="msg"
        [form]="userForm"
        [messagesObserver]="messages"
        [showNonFieldKeys]="TRUE"
        [showFieldName]="TRUE"
        [showFieldKeys]="FALSE"
      ></messages>
    </form>
  </div>
</div>
